import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../auth/authSlice";
import QuizzesOverview from "./index";
import NewQuiz from "./NewQuiz";
import ViewQuiz from "./ViewQuiz";
import AIQuiz from "./AIQuiz";
import SharedQuizzes from "./SharedQuizzes";
import ReportList from "./ReportList";
import QuizSubmissions from "./ReportList/QuizSubmissions";

const QuizzesRouter = () => {
  const user = useSelector(selectCurrentUser);
  const userRoles = user?.roles?.map((r) => r?.role?.name).filter(Boolean) || [];
  const isAdmin = userRoles.includes("admin");
  const isTeacher = userRoles.includes("teacher");
  const isExaminer = userRoles.includes("examiner");

  // Block quiz creation only for admin-only users (no examiner or teacher role)
  const blockQuizCreation = isAdmin && !isExaminer && !isTeacher;

  return (
    <Routes>
      <Route index element={<QuizzesOverview />} />
      <Route path="new" element={blockQuizCreation ? <Navigate to="." replace /> : <NewQuiz />} />
      <Route path="ai" element={blockQuizCreation ? <Navigate to="." replace /> : <AIQuiz />} />
      <Route path="view/:id" element={<ViewQuiz />} />
      <Route path="shared" element={<SharedQuizzes />} />
      <Route path="report-list" element={<ReportList />} />
      <Route path="report-list/:quizId/submissions" element={<QuizSubmissions />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
};

export default QuizzesRouter;
